import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Dashboard } from '@mui/icons-material';

const AdminHeader = () => {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #232536 0%, #374151 100%)',
        color: 'white',
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Dashboard sx={{ fontSize: 40, color: '#ffda1b' }} />
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 700, mb: 1 }}>
              Admin Dashboard
            </Typography>
            <Typography variant="h6" sx={{ color: '#e2e8f0' }}>
              Manage your GCC Tax Laws platform
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AdminHeader;
